import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import { formatDate } from '../../helper';
import { RootState } from '../../redux/store';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const ActiveSinceComponent = () => {
    const { selectedClient } = useSelector((state: RootState) => state.client);

    return <CardWrapper flex={1} minHeight="250px">
        <Typography variant="h6" color="textSecondary">Active Since</Typography>
        <Typography color={brand[300]} variant="h5" my={2}>{formatDate(selectedClient?.created_at as string || '', {
            month: 'long'
        })},<br /> {selectedClient?.created_at.split('-')[0]}</Typography>
        {/* <Button variant="outlined" fullWidth>Archive Company</Button> */}
    </CardWrapper>;
};

export default ActiveSinceComponent;